"use client"

import { useState, useCallback, useMemo } from "react"

// Types
interface DemoFormData {
  [key: string]: any
}

interface UseDashboardLayoutReturn {
  // Modal state
  isModalOpen: boolean
  openModal: () => void
  closeModal: () => void
  handleDemoClick: () => void
  handleFormSubmit: (data: DemoFormData) => void

  // Sidebar state
  sidebarCollapsed: boolean
  toggleSidebar: () => void
  mainClassName: string
}

export const useDashboardLayout = (): UseDashboardLayoutReturn => {
  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Sidebar state
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  // Modal handlers
  const openModal = useCallback(() => setIsModalOpen(true), [])
  const closeModal = useCallback(() => setIsModalOpen(false), [])

  const handleDemoClick = useCallback(() => {
    setIsModalOpen((prev) => !prev)
  }, [])

  const handleFormSubmit = useCallback((data: DemoFormData) => {
    // TODO: Implement proper form submission logic
    alert("Demo request submitted successfully!")
    setIsModalOpen(false)
  }, [])

  // Sidebar handlers
  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed((prev) => !prev)
  }, [])

  // Memoized values
  const mainClassName = useMemo(
    () => `dashboard-main ${sidebarCollapsed ? "sidebar-collapsed" : ""}`,
    [sidebarCollapsed],
  )

  return {
    isModalOpen,
    openModal,
    closeModal,
    handleDemoClick,
    handleFormSubmit,
    sidebarCollapsed,
    toggleSidebar,
    mainClassName,
  }
}
